module.exports = __webpack_public_path__ + "img/icon-empty-avatar-header.825718e5.svg";